import React from "react";
import { BsPlayFill } from "react-icons/bs";
import { BiRefresh } from "react-icons/bi";
import { HiSparkles } from "react-icons/hi";
import "./PersonalizedLectures.scss";
import { useNavigate } from "react-router-dom";

const PersonalizedLecturesCard = () => {
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate("/dashboard/personalized-lectures");
  }

  return (
    <div className="personalized_card">
      {/* LEFT ICON */}
      <div className="card_icon">
        <HiSparkles size={26} />
      </div>

      {/* CENTER CONTENT */}
      <div className="card_left">
        <h4>Personalized Lectures</h4>
        <p>
          Check personalized lectures assigned to you !
        </p>

        {/* <div className="card_tags">
          <span>Weak Topics</span>
          <span>Missed Classes</span>
          <span>Revision</span>
        </div> */}
      </div>

      {/* RIGHT BUTTON GROUP */}
      <div className="card_actions">
        <button className="dashboard_button">
          <BiRefresh size={18} className="mx-1" />
          Refresh
        </button>

        <button className="dashboard_button primary" onClick={handleNavigate}>
          <BsPlayFill size={18} className="mx-1" />
          View Lectures
        </button>
      </div>
    </div>
  );
};

export default PersonalizedLecturesCard;
